import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const HTMLContentWrapper = styled.div`
  line-height: 1.43;

  & > :first-child {
    margin-top: 0;
  }
  h1 {
    font-size: 24px;
  }

  h2 {
    font-size: 18px;
  }

  p,
  a {
    font-size: 14px;
  }

  a {
    color: ${themeGet('colors.link')};
    text-decoration: none;
  }
`;

export const HTMLContent = ({ html }) => <HTMLContentWrapper dangerouslySetInnerHTML={{ __html: html }} />;
